import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { initAppNotifications } from '../../utils/appNotifications';
import { widgetJetonuYaz } from '../../utils/widgetKoprusu';

const AppNotificationsBootstrap = () => {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (!token || !user || started.current) return;
    started.current = true;
    initAppNotifications(navigate);
  }, [token, user, navigate]);

  /* Ana ekran widget'i uygulamanin verisini goremez; kendi basina
     sunucuya sorar. Bunun icin oturum jetonuna ihtiyaci var.
     Jeton her degistiginde (giris, yenileme) paylasilan alana yaziliyor.

     Yetki bilgisi GONDERILMIYOR: widget galerisi artik hicbir veri
     gostermiyor (yalnizca kartin ne ise yaradigini yazan bir tanitim),
     dolayisiyla cihazda yetki bilmesine gerek yok. Kasa rakamlarini
     kimin gorecegine sunucu karar veriyor. */
  useEffect(() => {
    if (!token) return;
    widgetJetonuYaz(token, 'personel');
  }, [token]);

  return null;
};

export default AppNotificationsBootstrap;
